import { mergeWith, clone } from 'lodash';

const black = { r: 0, g: 0, b: 0 };

// assuming that you can have objects with { r: 255, g: 255, b: 255 }
const interpolateInner = (colorFrom, colorTo, ratio) => {
  const { r, g, b } = mergeWith(clone(colorFrom), colorTo, (from, to) =>
    Math.floor(from + (to - from) * ratio)
  );
  return `rgb(${r}, ${g}, ${b})`;
};

/**
 * Interpolate an array of RGB colors.
 *
 * @param {Array} colors - an array of rgb object colors (eg: { r: 255, g: 0, b: 0 }).
 * @param {Number} ratio - the ratio to mix by (between 0 and 1).
 * @returns {Function} - an interpolation function
 **/
const interpolateColors = colors => ratio => {
  const colorsLength = colors.length;

  if (colorsLength === 0) return 'rgb(0, 0, 0)';
  if (colorsLength === 1) return interpolateInner(black, colors[0], ratio);
  if (colorsLength === 2) return interpolateInner(colors[0], colors[1], ratio);

  const binWidth = 1.0 / (colorsLength - 1);

  const colorBucket = Math.floor(ratio / binWidth);

  // color to pick with the bucketed color. ie 0 needs 1, last needs last-1 etc
  const colorPair =
    colorBucket >= colorsLength - 1 ? colorsLength - 1 : colorBucket + 1;

  const interpolatedRatio = (ratio - colorBucket * binWidth) / binWidth;

  const fst = Math.min(colorBucket, colorPair);
  const snd = Math.max(colorBucket, colorPair);

  return interpolateInner(colors[fst], colors[snd], interpolatedRatio);
};

export default interpolateColors;
export { interpolateColors };
